import script from "./whGOnceImg2.vue?vue&type=script&setup=true&lang=js"
export * from "./whGOnceImg2.vue?vue&type=script&setup=true&lang=js"

import "./whGOnceImg2.vue?vue&type=style&index=0&id=138f47b0&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-138f47b0"]])

export default __exports__